import { Button, Stack, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";
import DocumentsHandler from "../../Documents/Handler";
import StepBottomBar from "../StepBottomBar";
import StepLayout from "../StepLayout";

/**
 * @typedef {Object} Props
 * @property {() => void} nextStep
 *
 * @param {Props} props
 */
function StepDocuments({ nextStep }) {
  const intl = useIntl();

  return (
    <StepLayout title={intl.formatMessage({ defaultMessage: "Justificatifs" })}>
      <Stack spacing="1rem" p="1rem">
        <Text colorScheme="gray">
          <FormattedMessage defaultMessage="Vos documents justificatifs doivent être valables pour l'année courante et nous servent à vérifier les informations sur votre compte et vos adhérents." />
        </Text>

        <DocumentsHandler withYearSelector={false} />
      </Stack>

      <StepBottomBar>
        <Button onClick={() => nextStep()} colorScheme="brandSecondary">
          <FormattedMessage defaultMessage="Continuer" />
        </Button>
      </StepBottomBar>
    </StepLayout>
  );
}

export default StepDocuments;
